import { Component } from '@angular/core';
import {
  DsBoxModule, DsButtonModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsModalModule,
  DsToastService,
} from '@bmw-ds/components';
import { StockService } from '../../../services/stock.service';
import { CampaignDetailsRequest } from '../../../models/campaign-details.component';

@Component({
  selector: 'app-campaign-details',
  templateUrl: './campaign-details.component.html',
  imports: [DsBoxModule, DsModalModule, DsButtonModule],
  styleUrls: ['./campaign-details.component.css'],
})
export class CampaignDetailsComponent {
  constructor(
    private stockService: StockService,
    private loadingAreaService: DsLoadingAreaService,
    private toastService: DsToastService
  ) {}
  getCampaignDetails: CampaignDetailsRequest = {
    vin: '',
    bodyno: '',
  };
  campaignDetail: {
    imageUrl: string;
    modelDescription: string;
    campaign: string;
    vin: string;
    recallText: string;
  } = {
    imageUrl: '',
    modelDescription: '',
    campaign: '',
    vin: '',
    recallText: '',
  };
  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'bodyLoading' };

  campaignDetailsModalIsOpen: boolean = false;
  getCampaignDetailsModalIsOpen(
    vin: string,
    model: string,
    imageUrl: string,
    deliveryStop: string
  ) {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Loading campaign details',
    };
    this.campaignDetail.vin = vin;
    this.campaignDetail.modelDescription = model;
    this.campaignDetail.imageUrl = imageUrl;

    this.getCampaignDetails.vin = vin;
    this.getCampaignDetails.bodyno = '';
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.stockService.getCampaignDetails(this.getCampaignDetails).subscribe(
      (response) => {
        console.log(response);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        // this.campaignDetail.recallText = response.recallCampaigns.map((recall) => recall.recallText).join(', ');
        //  this.campaignDetail.campaign = response.recallCampaigns.map((recall) => recall.campaign).join(', ');
        const sortedRecalls = response.recallCampaigns.sort((a, b) => a.recallId.localeCompare(b.recallId));
        this.campaignDetail.recallText =
          sortedRecalls.at(0)?.recallText || '';
        this.campaignDetail.campaign =
          sortedRecalls.at(0)?.campaign || '';

        //   response.recallCampaigns[0]?.recallText || '';
        // this.campaignDetail.campaign =
        //   response.recallCampaigns[0]?.campaign || '';
        this.campaignDetailsModalIsOpen = true;
      },
      (error) => {
        console.log(error);
        this.toastService.pushToast({
          id: 'error-toast',
          tone: 'critical',
          toastText: 'Failed to fetch campaign details.',
        });
      }
    );
  }

  closeModal(): void {
    this.campaignDetailsModalIsOpen = false;
  }
}
